import React, { Component } from "react";
import { Row, Card, Col } from "antd";

class TabContract extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div>
        <Card title="基本信息">
          <Row>
            <Col span={7}>
              <span>公司名称：</span>
              <span>万福集团</span>
            </Col>
            <Col span={7}>
              <span>联系人员：</span>
              <span>杨万福</span>
            </Col>
            <Col span={7}>
              <span>联系电话：</span>
              <span>13565555555</span>
            </Col>
          </Row>
          <Row>
            <Col span={7}>
              <span>所属行业：</span>
              <span>制造</span>
            </Col>
            <Col span={7}>
              <span>所在区域：</span>
              <span>杭州西湖</span>
            </Col>
            <Col span={7}>
              <span>详细地址：</span>
              <span>西溪新座6幢</span>
            </Col>
          </Row>
        </Card>
        <Card title="附件">
          <Row>
            <Col span={10}>
              <span>点击上传BP</span>
            </Col>
            <Col span={10}>
              <span>选择文件</span>
            </Col>
          </Row>
        </Card>
      </div>
    );
  }
}
export default TabContract;



// WEBPACK FOOTER //
// ./src/components/client/manage/TabFile.js